var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, firstImageEntityProperty, firstStringProperty } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { EntityLinkButton } from './entity-link-button';
import { LinkButton } from '../elements/link-button';
import { ImageEntityBackground } from './image-entity-background';
import { useLang } from '../hooks/use-lang';
var cls = classNames('block-tout');
export var BlockToutDefaultProps = {
  aspectRatio: {
    base: 16 / 9
  },
  colors: {
    text: 'strong',
    fill: 'strong',
    border: 'strong'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    ", ";\n  "], ["\n    height: 100%;\n    ", ";\n  "])), theme.APPLY_COLORS)
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    justify-content: space-between;\n    padding: ", ";\n    height: 100%;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    justify-content: space-between;\n    padding: ", ";\n    height: 100%;\n  "])), theme.UNIT(6))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 500;\n    margin: 0;\n    font-size: ", ";\n    padding-bottom: ", ";\n  "], ["\n    color: ", ";\n    font-weight: 500;\n    margin: 0;\n    font-size: ", ";\n    padding-bottom: ", ";\n  "])), theme.COLOR('light'), theme.FONT_SIZE(18), theme.UNIT(1))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-weight: 300;\n    margin: 0;\n    font-size: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-weight: 300;\n    margin: 0;\n    font-size: ", ";\n    padding-bottom: ", ";\n  "])), theme.FONT_SIZE(18), theme.UNIT(2))
});
var ContentStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(10))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var PageLinkButtonStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles)
});
var LinkButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), ButtonStyles)
});
var LabelStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    color: ", ";\n    height: 80px;\n    font-size: ", ";\n    text-transform: uppercase;\n    display: block;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 ", ";\n  "], ["\n    ", ";\n    color: ", ";\n    height: 80px;\n    font-size: ", ";\n    text-transform: uppercase;\n    display: block;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 0 ", ";\n  "])), theme.H_DOT_BG('light'), theme.COLOR('light'), theme.FONT_SIZE(14), theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: styled(ImageEntityBackground)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h2.attrs(cls.attr('title'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Subtitle: styled.h3.attrs(cls.attr('subtitle'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  Content: styled(ContentNode)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  PageLinkButton: styled(EntityLinkButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), PageLinkButtonStyles),
  LinkButton: styled(LinkButton)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LinkButtonStyles),
  Label: styled.div.attrs(cls.attr('label'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var BlockTout = function (props) {
  var _a, _b;
  var className = props.className,
    entity = props.entity,
    aspectRatio = props.aspectRatio,
    colors = props.colors;
  var link = entity.link,
    page = entity.page,
    backgroundColor = entity.backgroundColor,
    color = entity.color,
    subtitle = entity.subtitle,
    content = entity.content;
  var title = entity.title || entity.page && entity.page.title;
  var image = firstImageEntityProperty(entity, ['image', 'page.banner']);
  var buttonColors = {
    fill: 'strong',
    border: 'strong',
    text: 'strong'
  };
  var t = useLang();
  var hasLink = !!link;
  var hasPage = page && !hasLink;
  return React.createElement(My.Container, {
    colors: __assign(__assign({}, colors), {
      background: (_a = entity.backgroundColor) === null || _a === void 0 ? void 0 : _a.value,
      text: (_b = entity.color) === null || _b === void 0 ? void 0 : _b.value
    }),
    aspectRatio: aspectRatio,
    entity: image,
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.Body, null, title && React.createElement(My.Title, null, title), subtitle && React.createElement(My.Subtitle, null, subtitle), content && React.createElement(My.Content, {
    entity: content
  })), hasLink && (link.url ? React.createElement(My.LinkButton, {
    colors: buttonColors,
    isDownload: link.isDownload,
    href: link.url
  }, t(firstStringProperty(link, ['label', 'name']))) : React.createElement(My.Label, null, t(firstStringProperty(link, ['label', 'name'])))), hasPage && React.createElement(My.PageLinkButton, {
    colors: buttonColors,
    entity: page
  }, page.name)));
};
BlockTout.defaultProps = BlockToutDefaultProps;
BlockTout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;